import { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Layout from "@components/shared/layout";
import MenuLateralUsuario from "@components/menu_lateral_usuario";
import FormElegibilidade from "@components/consulta_eletiva/EligibilityForm";
import FormSolicitacao from "@components/consulta_eletiva/form_solicitacao";
import AreaResultado from "@components/consulta_eletiva/area_resultado/AreaResultado";
import {
  getPrestador,
  updatePrestador,
  postCobranca,
  resetBeneficiarioState,
  resetExameState,
  autorizarProcedimentos,
  clearBiometrics,
  requireBiometrics,
  saveBiometrics,
} from "@store/actions";
import CustomSnackbar from "@components/shared/custom_snackbar";
import m from "@utils/strings";
import _ from "lodash";
import "@styles/consulta-eletiva.css";
import { updateBeneficiatioState as updateBeneficiaryState } from "@store/actions/index";
import RequisicaoSolicitacaoProcedimentos from "@config/types/requests/RequisicaoSolicitacaoProcedimentos";
import ValidatePrestadorLoader from "@components/shared/ValidatePrestadorLoader";
import BiometricsModal from "@components/BiometricsModal";
import Loader from "@components/shared/Loader";

const DEFAULT_PROCEDURE = {
  Codigo: 10101012,
  Tabela: 22,
  Descricao: "CONSULTA EM CONSULTÓRIO (NO HORÁRIO NORMAL OU PREESTABELECIDO)",
  quantidade: 1,
  RequerAuditoria: false,
};

const TIPO_ATENDIMENTO = 4;
const WILL_AUTHORIZE = false;

class ConsultaEletiva extends Component {
  constructor(props) {
    super(props);
    this.state = {
      beneficiarioDTO: {},
      showLoader: false,
      profissionalExecutante: {},
      identificadorCobranca: "",
      snackbarMsg: "",
      snackbarType: "success",
      showResultArea: false,
      result: {},
      step: 0,
    };
    this.props.resetExameState();
    this.isFetchingPrestador = false;
  }

  componentDidMount() {
    this.props.resetBeneficiarioState();
    this.focusFirstFieldAutorizacao();
  }

  //#region Page Access Control
  setStep = (step) => {
    this.setState({ step: step });
  };

  showLoader = () => {
    this.setState({ showLoader: true });
  };

  hideLoader = () => {
    this.setState({ showLoader: false });
  };

  //#endregion
  updateDadosBeneficiario = (data) => {
    this.setState({
      beneficiarioDTO: data.beneficiarioDTO,
    });
  };

  updateDadosSolicitacao = (data) => {
    this.setState({
      profissionalExecutante: data.profissionalExecutante,
    });
  };

  handleEligibilityResponse = (error, result = null) => {
    this.showLoader();
    if (error) {
      this.openSnackbar(error.message, "error");
      this.setResult(error.message, error.motive);
      this.hideLoader();
      return;
    }
    const {
      data: { Biometria },
    } = result;
    if (Biometria.Utiliza) {
      this.props.requireBiometrics();
      return;
    }
    this.validateSolicitacaoFieldsRef();
  };

  getBiometryResponse = (data) => {
    if (data.response == 400) {
      this.openSnackbar(data.message, "error");
      this.setState({
        showResultArea: true,
        result: { type: "denied", message: data.message },
      });
      this.validateSolicitacaoFieldsRef(true);
      this.props.clearBiometrics();
      return;
    }
    this.openSnackbar(data.message, "success");
    this.validateSolicitacaoFieldsRef();
    this.props.clearBiometrics();
  };

  novoAtendimento = () => {
    this.props.resetBeneficiarioState();
    this.props.clearBiometrics();
    this.resetFormFieldsStates();
    this.resetFormFieldsStatesSolicitacao();
    this.focusFirstFieldAutorizacao();
    this.setState({
      beneficiarioDTO: {},
      showLoader: false,
      profissionalExecutante: {},
      snackbarMsg: "",
      snackbarType: "success",
      identificadorCobranca: "",
      showResultArea: false,
      result: {},
      step: 0,
    });
  };

  openSnackbar = (snackbarMsg, snackbarType) => {
    this.setState({ snackbarMsg, snackbarType });
    this.click();
  };

  setResult = (msg, status) => {
    this.setState({
      showResultArea: true,
      result: { type: status, message: msg },
    });
  };

  autorizarConsultaEletiva = (dadosAtendimento) => {
    const { prestador } = this.props;
    const { beneficiarioDTO: beneficiario, RN } = this.state;
    const autorizacao = {
      CNPJPrestador: prestador.CPF_CNPJ,
      NomePrestador: prestador.Nome,
      NumeroCarteiraBeneficiario: beneficiario.NumeroCarteiraBeneficiario,
      NomeBeneficiario: beneficiario.NomeBeneficiario,
      CartaoNacionalSaude: beneficiario.CartaoNacionalSaude,
      DataAtual: beneficiario.DataAtendimento,
      HoraAtual: "",
      RecemNascido: RN,
      RegistroANS: beneficiario.RegistroANS,
      willAuthorize: WILL_AUTHORIZE,
      TipoAtendimento: TIPO_ATENDIMENTO,
    };
    const procedimentos = {
      procedimentos: [DEFAULT_PROCEDURE],
      indicacaoClinica: "",
      indicacaoClinicaNormal: "",
    };
    const observacao = JSON.stringify({
      isExec: true,
      indAci: dadosAtendimento.indicacaoAcidente,
      isCons: true,
      tpCons: dadosAtendimento.tipoConsulta,
      obsGui: "AUTORIZADOR",
    });
    let requisicaoProcedimentos = new RequisicaoSolicitacaoProcedimentos(
      autorizacao,
      this.state.profissionalExecutante,
      procedimentos,
      observacao
    );
    this.setStep(2);
    this.props.autorizarProcedimentos(
      requisicaoProcedimentos,
      (result) => {
        dadosAtendimento.numeroGuiaOperadora = result.data.SolicitacaoProcedimento.NumeroGuiaOperadora;
        let cobrancaParams = new ParametrosCobranca(
          this.props.prestador,
          this.state.beneficiarioDTO,
          this.state.profissionalExecutante,
          dadosAtendimento
        );
        this.setStep(3);
        this.props.postCobranca(
          cobrancaParams,
          (result) => {
            this.openSnackbar(
              m.TELA_CONSULTA_ELETIVA.MENSAGEM_ATENDIMENTO_CONLUIDO,
              "success"
            );
            this.setResult("", "success");
            this.hideLoader();
          },
          (error) => {
            this.props.updateBeneficiaryState("API_ERROR");
            this.openSnackbar(
              m.TELA_CONSULTA_ELETIVA.MENSAGEM_ERRO_SOLICITAR_CONSULTA,
              "error"
            );
            this.setResult(
              m.TELA_CONSULTA_ELETIVA.MENSAGEM_API_ERROR_SUBTITULO,
              "error"
            );
            this.hideLoader();
          }
        );
      },
      (error) => {
        this.props.updateBeneficiaryState("API_ERROR");
        this.setResult(
          m.TELA_CONSULTA_ELETIVA.MENSAGEM_API_ERROR_SUBTITULO,
          "error"
        );
        this.openSnackbar(
          m.TELA_CONSULTA_ELETIVA.MENSAGEM_ERRO_SOLICITAR_CONSULTA,
          "error"
        );
        this.hideLoader();
      }
    );
  };

  verificarSeCamposSolicitacaoEstaoPreenchidos = () => {
    return this.verifyIfSolicitacaoFieldsIsFilled();
  };

  validateAutorizacaoFieldsRef = () => {
    this.validateAutorizacaoFields();
  };

  validateSolicitacaoFieldsRef = (booleano) => {
    this.validateSolicitacaoFields(booleano);
  };

  render() {
    return (
      <div>
        <ConsultaEletivaLoader
          visible={this.state.showLoader}
          step={this.state.step}
        />
        <ValidatePrestadorLoader />
        <Layout
          user={this.props.user}
          iconePath={"../images/consulta_eletiva.png"}
          alt={m.TELA_CONSULTA_ELETIVA.TITULO_TELA_CONSULTA_ELETIVA}
          content={m.TELA_CONSULTA_ELETIVA.TITULO_TELA_CONSULTA_ELETIVA}
        />
        <MenuLateralUsuario
          beneficiario={this.props.beneficiario}
          exame={this.props.exame}
          resetStates={this.resetAllStateExceptForBeneficiario}
        />
        <FormElegibilidade
          beneficiario={this.props.beneficiario}
          willAuthorize={WILL_AUTHORIZE}
          updateDadosBeneficiario={this.updateDadosBeneficiario}
          setInitialFieldsState={(e) => (this.resetFormFieldsStates = e)}
          prestador={this.props.prestador}
          tipoAtendimento={TIPO_ATENDIMENTO}
          openSnackbar={this.openSnackbar}
          onEligibilityResponse={this.handleEligibilityResponse}
          focusFirstFieldAutorizacao={(e) =>
            (this.focusFirstFieldAutorizacao = e)
          }
          validateAutorizacaoFields={(e) =>
            (this.validateAutorizacaoFields = e)
          }
          changeWhichAreaResultadoShow={this.changeWhichAreaResultadoShow}
          verificarSeCamposSolicitacaoEstaoPreenchidos={
            this.verificarSeCamposSolicitacaoEstaoPreenchidos
          }
          novoAtendimento={this.novoAtendimento}
        />
        <FormSolicitacao
          submitFormElegibilidade={this.validateAutorizacaoFieldsRef}
          updateDadosSolicitacao={this.updateDadosSolicitacao}
          setInitialFieldsState={(e) =>
            (this.resetFormFieldsStatesSolicitacao = e)
          }
          validateSolicitacaoFields={(e) =>
            (this.validateSolicitacaoFields = e)
          }
          openSnackbar={this.openSnackbar}
          autorizarConsultaEletiva={this.autorizarConsultaEletiva}
          prestador={this.props.prestador}
          verifyIfSolicitacaoFieldsIsFilled={(e) =>
            (this.verifyIfSolicitacaoFieldsIsFilled = e)
          }
        />
        <AreaResultado
          show={this.state.showResultArea}
          result={this.state.result}
          onFinish={this.novoAtendimento}
        />
        <BiometricsModal
          url={this.props.beneficiario?.data?.Biometria?.Url}
          onBiometryResponse={this.getBiometryResponse}
          onClose={this.novoAtendimento}
        />
        <CustomSnackbar
          setClick={(click) => (this.click = click)}
          variant={this.state.snackbarType}
          duration={2500}
          content={this.state.snackbarMsg}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    biometrics: state.biometrics,
    user: state.oidc.user,
    beneficiario: state.beneficiario,
    exame: state.exame,
    prestador: state.prestador,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      autorizarProcedimentos,
      resetBeneficiarioState,
      getPrestador,
      updatePrestador,
      postCobranca,
      resetExameState,
      updateBeneficiaryState,
      saveBiometrics,
      requireBiometrics,
      clearBiometrics,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ConsultaEletiva);

function ConsultaEletivaLoader({ visible, step }) {
  let message = null;
  switch (step) {
    case 2:
      message = m.TELA_CONSULTA_ELETIVA.LOADER_AUTORIZAR_CONSULTA;
      break;
    case 3:
      message = m.TELA_CONSULTA_ELETIVA.LOADER_GERAR_GUIA;
      break;
    default:
      message = null;
  }
  return <Loader visible={visible} message={message} />;
}

class ParametrosCobranca {
  NomeBeneficiario;
  NumeroCarteiraBeneficiario;
  RN;
  CNS;
  DataAtendimento;
  NomeProfissional;
  CodigoConsulta;
  CodigoTipoAtendimento;
  tipoGuia;
  conselhoProfissional;
  estadoProfissional;
  numeroConselhoProfissional;
  codigoCBOProfissional;
  cpfCnpjPrestador;
  numeroGuiaOperadora;
  constructor(
    prestador,
    beneficiario,
    profissionalExecutante,
    dadosAtendimento
  ) {
    this.NomeBeneficiario = beneficiario.NomeBeneficiario;
    this.NumeroCarteiraBeneficiario = beneficiario.NumeroCarteiraBeneficiario;
    this.RN = beneficiario.RN ? beneficiario.RN : false;
    this.CNS = beneficiario.CartaoNacionalSaude;
    this.DataAtendimento = beneficiario.DataAtendimento;
    this.NomeProfissional = profissionalExecutante.Nome;
    this.CodigoConsulta = dadosAtendimento.tipoConsulta;
    this.CodigoTipoAtendimento = dadosAtendimento.indicacaoAcidente;
    this.tipoGuia = "CONSULTA";
    this.conselhoProfissional = profissionalExecutante.Conselho;
    this.estadoProfissional = profissionalExecutante.Estado;
    this.numeroConselhoProfissional = profissionalExecutante.Numeroconselho;
    this.codigoCBOProfissional = profissionalExecutante.ocupacao.id;
    this.cpfCnpjPrestador = prestador.CPF_CNPJ;
    this.numeroGuiaOperadora = dadosAtendimento.numeroGuiaOperadora;
  }
}
